module.exports = __webpack_public_path__ + "img/panther-tiger.d56d39a3.png";